import React, { useState, useEffect } from "react";
import Layout1 from "../../components/layout1";
import SubHeader from "../../components/subHeader";
import { loaderReducer } from "../../components/toolkit/loader";
import { useDispatch } from "react-redux";
import Cookies from "universal-cookie";
import { HiPlus } from "react-icons/hi";
import { IoIosSearch } from "react-icons/io";
import Content from "./content";
import SurveyTemplate from "./content/surveyTemplate";
import QestionnaireTem from "./questionnaireTemplate/questionnaireTemplate";
import { useCan } from "../../utils/permissions";
import {
  createSurveyTemplate,
  List,
  Update,
  SearchList
} from "../../functions/surveyTemplate";
import {
  createGenericTemplate,
  ListGenericTemplate,
  UpdateGenericTemplate,
} from "../../functions/genericTemplate";
import { toast } from "react-toastify";
// import userCheck from "../../utils/checkUser";

const Index = () => {
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const token = cookies.get("token");
  const userName = cookies.get("userName");
  const can = useCan();
  const canCreatesurveyTemplate = can("surveyTemplate", "delete");
  const canUpdateTemplate = can("surveyTemplate", "update");
  const [showButton, setShowButton] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [pageC, setPageC] = useState(1);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState("");
  var [listData, setListData] = useState([]);
  const [customImageUpload, setCustomImageUpload] = useState([]);
  const [customTextField, setCustomTextField] = useState([]);
  const [customDropDown, setCustomDropDown] = useState([]);
  const [customImageUpload1, setCustomImageUpload1] = useState([]);
  const [customTextField1, setCustomTextField1] = useState([]);
  const [customDropDown1, setCustomDropDown1] = useState([]);
  const [jobTypeList, setJobTypeList] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  var [genericTemplateListData, setGenericTemplateListData] = useState([]);
  const [genericTemplateJobTypeList, setGenericTemplateJobTypeList] = useState(
    []
  );
  const [editDataGenericTemplate, setEditDataGenericTemplate] = useState("");
  const [isGTEdit, SetIsGTEdit] = useState(false);
  const [qtFormData, setQTFormData] = useState({
    title: "",
    tranId: "",
    jobType: "",
    id: "",
  });
  const [qtdropdowns, setQTDropDowns] = useState([]);

  // Disable Questionnaire button State
  const [questionnaireButtonDisable, setQuestionnaireButtonDisable] =
    useState(false);
  // console.log("questionnaireButtonDisable -->", questionnaireButtonDisable);

  const showModal = () => {
    setIsEdit(false);
    setIsModalOpen(true);
  };
  const showModal1 = () => {
    // console.log("object", questionnaireButtonDisable);
    if (questionnaireButtonDisable) {
      SetIsGTEdit(true);
      setIsModalOpen1(false);
    } else {
      SetIsGTEdit(false);
      setIsModalOpen1(true);
    }
  };

  function generateCustomTranId() {
    let tranId = "";
    const characters = "0123456789";
    for (let i = 0; i < 5; i++)
      tranId += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    return tranId;
  }

  const handleOk = async (
    formData,
    dropdowns,
    setDropDowns,
    setFormData,
    isEdit
  ) => {
    formData["customSurvey"] = dropdowns;

    if (!isEdit) {
      dispatch(loaderReducer(true));
      const newTranId = generateCustomTranId();
      formData["tranId"] = `SO${newTranId}`;
      await createSurveyTemplate(token, formData)
        .then((res) => {
          console.log("res", res.data);
          toast.success(`${res.data.message}`);
          setDropDowns([]);
          setFormData({
            title: "",
            tranId: "",
            jobType: "",
          });
          fetchData();
          dispatch(loaderReducer(false));
        })
        .catch((err) => {
          console.log(err, "err");
          dispatch(loaderReducer(false));
          toast.error(err.message);
        });
    } else {
      dispatch(loaderReducer(true));
      try {
        await Update(formData.id, token, formData)
          .then((res) => {
            dispatch(loaderReducer(false));
            toast.success(`${res.data.message}`);
            fetchData();
            setDropDowns([]);
            setFormData({
              title: "",
              tranId: "",
              jobType: "",
              id: "",
            });
          })
          .catch((err) => {
            dispatch(loaderReducer(false));
            toast.error(`Getting error ${err}`);
          });
      } catch (error) {
        toast.error(error);
        dispatch(loaderReducer(false));
      }
    }
    setIsModalOpen(false);
    setIsModalOpen1(false);
  };

  const handleCancel = (setDropDowns, setFormData) => {
    setDropDowns([]);
    setFormData({
      title: "",
      tranId: "",
      jobType: "",
      id: "",
    });
    setIsModalOpen(false);
    setIsModalOpen1(false);
    setIsEdit(false);
  };

  const qestionnaireTemHandleOk = async (
    qtFormData,
    dropdowns,
    setDropDowns,
    setFormData,
    isEdit
  ) => {
    qestionnaireTemHandleOk();
    setIsModalOpen(false);
    setIsModalOpen1(false);
  };

  const qestionnaireTemHandleCancel = (setQTDropDowns, setQTFormData) => {
    setQTDropDowns([]);
    setQTFormData({
      title: "",
      tranId: "",
      jobType: "",
    });
    setIsModalOpen(false);
    setIsModalOpen1(false);
    SetIsGTEdit(false);
  };

  const openEditModel = (value) => {
    setIsEdit(true);
    setIsModalOpen(true);
    setEditData(value);
  };

  const openEditGenericTemplateModel = (value) => {
    // console.log(value);
    SetIsGTEdit(true);
    setIsModalOpen1(true);
    setEditDataGenericTemplate(value);
  };

  // const fetchData = async () => {
  //   dispatch(loaderReducer(true));
  //   try {
  //     await List(token, pageC)
  //       .then((res) => {
  //         setListData(res.data.data.list);
  //         dispatch(loaderReducer(false));

  //         const uniqueJobTypesSet = new Set();
  //         res.data.data.list.forEach((detail) => {
  //           uniqueJobTypesSet.add(detail.jobType);
  //         });

  //         const uniqueJobTypesArray = Array.from(uniqueJobTypesSet);
  //         setJobTypeList(uniqueJobTypesArray);
  //       })
  //       .catch((err) => {
  //         dispatch(loaderReducer(false));
  //         console.log(err);
  //       });
  //   } catch (error) {
  //     dispatch(loaderReducer(false));
  //     toast.error(error || "Getting some issue, try again.");
  //   }
  // };

  // Define useEffect for set true and false for disable div
  // useEffect(() => {
  //   setQuestionnaireButtonDisable(!questionnaireButtonDisable);
  // }, [genericTemplateListData]);

  // const genericTemplateFetchData = async () => {
  //   dispatch(loaderReducer(true));
  //   try {
  //     await ListGenericTemplate(token, pageC)
  //       .then((res) => {
  //         setGenericTemplateListData(res.data.data.list);
  //         // console.log("res.data.data.list", res.data.data.list.length > 0);
  //         if (res.data.data.list.length > 0) {
  //           setQuestionnaireButtonDisable(true);
  //         } else {
  //           setQuestionnaireButtonDisable(false);
  //         }

  //         dispatch(loaderReducer(false));

  //         const uniqueJobTypesSet = new Set();
  //         res.data.data.list.forEach((detail) => {
  //           uniqueJobTypesSet.add(detail.jobType);
  //         });

  //         const uniqueJobTypesArray = Array.from(uniqueJobTypesSet);
  //         setGenericTemplateJobTypeList(uniqueJobTypesArray);
  //       })
  //       .catch((err) => {
  //         dispatch(loaderReducer(false));
  //         console.log(err);
  //       });
  //   } catch (error) {
  //     dispatch(loaderReducer(false));
  //     toast.error(error || "Getting some issue, try again.");
  //   }
  // };
  const genericTemplateFetchData = async () => {
    await getSurveyAndGenericList(dispatch);
  };

  const fetchData = async () => {
    await getSurveyAndGenericList(dispatch);
  };

  async function getSurveyAndGenericList(dispatch) {
    dispatch(loaderReducer(true));
    try {
      const res = await SearchList(token, searchValue);
      console.log(res.data.data.genericTemplateList);

      setListData(res.data.data.surveyTemplateList);
      dispatch(loaderReducer(false));

      const uniqueJobTypesSet = new Set();
      res.data.data.surveyTemplateList.forEach((detail) => {
        uniqueJobTypesSet.add(detail.jobType);
      });

      const uniqueJobTypesArray = Array.from(uniqueJobTypesSet);
      setJobTypeList(uniqueJobTypesArray);

      setGenericTemplateListData(res.data.data.genericTemplateList);
      if (res.data.data.genericTemplateList.length >= 1) {
        setQuestionnaireButtonDisable(true);
      } else {
        setQuestionnaireButtonDisable(false);
      }

      const uniqueGenericJobTypesSet = new Set();
      res.data.data.genericTemplateList.forEach((detail) => {
        uniqueGenericJobTypesSet.add(detail.jobType);
      });

      const uniqueGenericJobTypesArray = Array.from(uniqueGenericJobTypesSet);
      setGenericTemplateJobTypeList(uniqueGenericJobTypesArray);
    } catch (error) {
      dispatch(loaderReducer(false));
      console.log(error);
      toast.error(error || "Encountered an issue, please try again.");
    }
  }

  useEffect(() => {
    fetchData();
    if(canUpdateTemplate){
      setShowButton(true);
    }
    

  }, [canUpdateTemplate]);


  const handleChange = (e) => {
    const { value } = e.target;
    setSearchValue(value);
  };

  useEffect(() => {
    fetchData();
  }, [searchValue]);

  const submitSearch = () => {
    fetchData();
  };

  return (
    <Layout1>
      <SubHeader />
      <div style={{ background: " #f3f3f3" }} className="pt-2">
        <div className="calendercls mt-4">
          <div style={{ justifyContent: "space-between", display: "flex" }}>
            <div className="tupdate mt-2">Survey & Questionnaire Templates</div>
            <div className="mt-2 d-flex gap-2" style={{ cursor: "pointer" }}>
              {canCreatesurveyTemplate &&
                <>
                  <div
                    className="contd textClss"
                    style={{
                      backgroundColor: "#1C449C",
                      color: "white",
                      width: "19rem",
                      textDecoration: "none",
                      fontWeight: "600",
                      height: "fit-content",
                    }}
                    onClick={showModal}

                  >
                    Create New Survey Template
                    <span>
                      <HiPlus />
                    </span>
                  </div>
                  <div
                    className="contd textClss"
                    style={{
                      backgroundColor: questionnaireButtonDisable
                        ? "black"
                        : "#1C449C",
                      color: "white",
                      width: "19rem",
                      textDecoration: "none",
                      fontWeight: "600",
                      height: "fit-content",
                      cursor: questionnaireButtonDisable
                        ? "not-allowed"
                        : "pointer",
                      opacity: questionnaireButtonDisable ? 0.5 : 1,
                    }}
                    onClick={showModal1}
                  >
                    Create New questionnaire Template
                    <span>
                      <HiPlus />
                    </span>
                  </div>
                </>
              }
              {/* <div
                className="contd textClss"
                style={{
                  backgroundColor: "#1C449C",
                  color: "white",
                  width: "19rem",
                  textDecoration: "none",
                  fontWeight: "600",
                  height: "fit-content",
                }}
                onClick={showModal1}
              >
                Create New questionnaire Template
                <span>
                  <HiPlus />
                </span>
              </div> */}
            </div>
          </div>
          {/* search box */}
          <div className="position-relative mt-4" style={{ maxWidth: '300px' }}>
            <input
              type="search"
              className="form-control form-control-sm pe-7"
              placeholder="Search Orders"
              value={searchValue}
              onChange={(e) => handleChange(e)}
            />
            {searchValue === "" && (
            <IoIosSearch
              className="position-absolute top-50 translate-middle-y text-muted pe-none fs-5"
              style={{ right: '0.5rem', pointerEvents: 'none' }}
              aria-hidden="true"
            />
            )}
        </div>


          {/* Content part*/}
          <Content
            arg={{
              genericTemplateListData,
              genericTemplateFetchData,
              listData,
              openEditModel,
              openEditGenericTemplateModel,
              fetchData,
              showButton
            }}
          />
          <SurveyTemplate
            arg={{
              setIsModalOpen,
              isModalOpen,
              handleOk,
              handleCancel,
              customImageUpload,
              setCustomImageUpload,
              customTextField,
              setCustomTextField,
              customDropDown,
              setCustomDropDown,
              isEdit,
              editData,
              fetchData,
              jobTypeList,
              setJobTypeList,
            }}
          />
          <QestionnaireTem
            arg={{
              setIsModalOpen1,
              isModalOpen1,
              qestionnaireTemHandleOk,
              qestionnaireTemHandleCancel,
              // handleOk,
              // handleCancel,
              customImageUpload1,
              setCustomImageUpload1,
              customTextField1,
              setCustomTextField1,
              customDropDown1,
              setCustomDropDown1,
              isGTEdit,
              editDataGenericTemplate,
              genericTemplateFetchData,
              setGenericTemplateJobTypeList,
              genericTemplateJobTypeList,
            }}
          />
        </div>
      </div>
    </Layout1>
  );
};

export default Index;
